export default "__VITE_ASSET__eb3qH1nH__"